<template>
    <Header></Header>
    <Left></Left>
    <section class="container">
        <div>
            <div class="area_title">
                <p>내담자 그룹관리</p>
                <div class="area_button">
                    <button type="button" class="" @click="router.push({ name: 'groupAdd' })">
                        <span>그룹 작성</span>
                    </button>
                </div>
            </div>
            <div class="area_body">
                <div class="area_section">
                    <div class="area_search">
                        <div>
                            <label>검색조건</label>
                            <div>
                                <div class="select-wrap">
                                    <select name="searchType" v-model="state.searchType1">
                                        <option value="">선택해주세요.</option>
                                        <option v-for="item in searchCondition" :value="item.key">{{ item.name }}</option>
                                    </select>
                                </div>

                                <input
                                    type="text"
                                    name="searchText"
                                    v-model="state.searchText1"
                                    placeholder="검색어를 입력해주세요."
                                    v-on:keyup.enter="fnGetList(1)"
                                />
                            </div>
                        </div>

                        <div class="area_button">
                            <button
                                type="button"
                                @click="
                                    reset();
                                    fnGetList(1);
                                "
                            >
                                초기화
                            </button>
                            <button type="button" @click="fnGetList(1)">검색</button>
                        </div>
                    </div>
                </div>

                <div class="area_section">
                    <div class="area_table">
                        <div class="area_table_head">
                            <div class="select-wrap">
                                <select name="orderType" v-model="state.order" @change="fnGetList(1)">
                                    <option value="0">최근순</option>
                                    <option value="1">과거순</option>
                                </select>
                            </div>

                            <div class="total_length">
                                {{ $t("notice.total") }} : {{ CommonUtils.numberFormat(pageState.length) }} {{ $t("notice.count") }}
                            </div>
                        </div>
                        <div class="area_table_body">
                            <DataGrid
                                :list="pageState.list"
                                :columns="pageState.fields"
                                :totalLength="pageState.length"
                                :perPage="pageState.perPage"
                                :cntPage="pageState.cntPage"
                                :current-page="pageState.currentPage"
                                :isLoading="pageState.isLoading"
                                @onRowClick="fnRowClick"
                                @onPaging="fnGetList"
                                @onNextPage="fnGoPage"
                                @onPrevPage="fnGoPage"
                                @onFirstPage="fnGoPage"
                                @onLastPage="fnGoPage"
                            ></DataGrid>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script lang="ts" config>
    import {
        userStore,
        globalStore,
        DataGrid,
        reactive,
        watch,
        apiService,
        onMounted,
        router,
        Header,
        Left,
        ModalDefault,
        types,
        getMessageByCode,
        PageBtn,
        CommonUtils,
        CommonOptions,
        ItemAdd,
    } from "@/BaseComponent";

    export default {
        props: {},
        components: { Header, Left, ModalDefault, PageBtn, DataGrid, ItemAdd },
        setup() {
            const global = globalStore();
            const user = userStore();

            const dayAgo = new Date();

            const today = new Date();
            dayAgo.setDate(today.getDate() - 30);

            const state = reactive({
                startDate: "" as string,
                endDate: "" as string,
                searchType1: "" as string,
                searchText1: "" as string,
                dept: 0 as number,
                order: 0 as number,
                name: "" as string,
                writer: "" as string,

                isShowAddModal: false as boolean,
                data: {} as any,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,
            });

            const pageState = reactive({
                perPage: 10,
                cntPage: 5,
                currentPage: 1,
                list: [] as any,
                length: 0 as number,
                isLoading: false,
                fields: [
                    { key: "", label: "No.", class: "text-center" },
                    { key: "name", label: "그룹명", class: "text-center", clickable: true },

                    { key: "adName", label: "등록자", class: "text-center" },
                    {
                        key: "createDate",
                        label: "등록일",
                        class: "text-center",
                        render: (row: any) => {
                            return CommonUtils.dateFormat(row.createDate, ".", true);
                        },
                    },
                ],
            });

            const searchCondition = [
                { key: "name", name: "그룹명" },
                { key: "writer", name: "작성자" },
            ];

            onMounted(() => {
                // state.startDate = dayAgo.toLocaleDateString("sv-SE");
                // state.endDate = today.toLocaleDateString("sv-SE");
                fnGetList(1);
            });

            const reset = () => {
                state.startDate = "";
                state.endDate = "";
                state.searchType1 = "";
                state.searchText1 = "";
                state.dept = 0;
                state.order = 0;
                state.name = "";
                state.writer = "";
            };

            const fnGetList = async (page: number) => {
                pageState.currentPage = page;
                pageState.isLoading = true;
                const param: types.group.ReqGroupList = {
                    page: page,
                    size: pageState.perPage,
                    searchType: state.searchType1,
                    searchText: state.searchText1,
                    order: state.order,
                    name: state.name,
                    writer: state.writer,
                    startDate: "",
                    endDate: "",
                };
                let res: types.ResPaging = await apiService.group.list(param);

                if (res.returnCode === 0 && res.list) {
                    pageState.list = res.list.data;
                    pageState.length = res.list.recordsTotal;
                } else {
                    console.error(res.description);
                }
                pageState.isLoading = false;
            };

            const fnRowClick = (row: any, col: any) => {
                if (col.key === "name") router.push({ name: "groupDetail", params: { id: row.idx } });
            };

            const fnGoPage = (page: number) => {
                pageState.currentPage = page;
            };

            const setDateToToday = () => {
                state.startDate = dayAgo.toLocaleDateString("sv-SE");
                state.endDate = today.toLocaleDateString("sv-SE");
            };

            return {
                state,
                pageState,
                router,
                searchCondition,
                reset,
                fnRowClick,
                fnGoPage,
                fnGetList,
                CommonUtils,
                setDateToToday,
                CommonOptions,
            };
        },
    };
</script>
<style>
    .sch_list label:last-child {
        border-right: white;
    }
</style>
